import { useTranslation } from 'react-i18next';

import ModelDetails from '@components/model/ModelDetails';
import { Typography } from '@destination/components';

export default function Model() {
  const { t } = useTranslation(undefined, { keyPrefix: 'model_details' });

  return (
    <>
      <Typography variant="pageTitle">{t('page_title')}</Typography>
      <ModelDetails />
    </>
  );
}
